import { render, staticRenderFns } from "./controlHistorySelf.vue?vue&type=template&id=26f0f2cd&scoped=true&lang=pug&"
import script from "./controlHistorySelf.vue?vue&type=script&lang=js&"
export * from "./controlHistorySelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f0f2cd",
  null
  
)

export default component.exports